
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";



// Async thunk for fetching wallet transactions
export const fetchWalletTransaction = createAsyncThunk(
    "walletTransaction/fetch",
    async ({ endDate, startDate }, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/admin/wallet/walletTransaction",
                method: "GET",
                params: { startDate, endDate },
            });

            // console.log("Fetch Wallet Transactions API Response:", response);

            if (!response.data) {
                console.error("Invalid API response: No data field found.");
                return rejectWithValue("Invalid API response: No data field found.");
            }

            if (!response.data.transactions) {
                console.error("Invalid API response: Transactions field missing.");
                return rejectWithValue("Invalid API response: Transactions field missing.");
            }

            if (!Array.isArray(response.data.transactions)) {
                console.warn("Transactions field is not an array. Converting it.");
                return response.data.transactions ? [response.data.transactions] : [];
            }

            return response.data.transactions;
        } catch (error) {
            console.error("Error fetching wallet transactions:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred.");
        }
    }
);
export const uploadTransactions = createAsyncThunk(
    "walletTransaction/upload",
    async ({ file }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("transactions", file);

            const response = await request({
                endpoint: "/admin/wallet/makeUserWalletTransaction",
                method: "POST",
                body: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (!response.success) {
                return rejectWithValue(response.error || "Failed to upload Wallet Transactions.");
            }

            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to upload Wallet Transactions.");
        }
    }
)

const initialState = {
    walletTransactions: [], // Array to store all wallet transactions
    loading: false,
    error: null,
};

const walletTransactionSlice = createSlice({
    name: "walletTransaction",
    initialState,
    reducers: {
        addWalletTransactions: (state, action) => {
            state.walletTransactions = action.payload;
        },
        clearWalletTransactions: (state) => {
            state.walletTransactions = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Wallet Transactions
            .addCase(fetchWalletTransaction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWalletTransaction.fulfilled, (state, action) => {
                state.loading = false;
                state.walletTransactions = action.payload; // Update the wallet transactions array
            })
            .addCase(fetchWalletTransaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            })
            // Upload Transactions
            .addCase(uploadTransactions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(uploadTransactions.fulfilled, (state, action) => {
                state.loading = false;
                state.walletTransactions = action.payload; // Update the wallet transactions array
            })
            .addCase(uploadTransactions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message 
            })
    },
});

export const { clearWalletTransactions, addWalletTransactions } = walletTransactionSlice.actions;
export default walletTransactionSlice.reducer;